import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { fetchPartyExport } from '../api/client.js';
import { partyExportQueryKey } from '../api/queryKeys.js';

import type { PartyExport, PartySlug } from '@mixwire/contracts';

// A finished party's play log is settled history, so it never needs refetching.
export const usePartyExport = (slug: PartySlug): UseQueryResult<PartyExport> =>
  useQuery({
    queryKey: partyExportQueryKey(slug),
    queryFn: async () => fetchPartyExport(slug),
    staleTime: Infinity,
  });
